module.exports = __webpack_public_path__ + "img/model.923e388c.jpg";